/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Remove Icon component -
 * the minus counterpart of `MaterialAddIcon`.
 */
export const MaterialRemoveIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19 13H5V11H19V13Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialRemoveIcon;
